import { createTheme } from '@inappsis/react-inappsis-ui';
import { ThemeProvider } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import {
  enUS as materialEnglish,
  esES as materialSpanish
} from '@mui/material/locale';
import { createTheme as createMuiTheme } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import {
  enUS as pickerEnglish,
  esES as pickerSpanish
} from '@mui/x-date-pickers/locales';
import { SnackbarProvider } from 'contexts/SnackbarContext';
import { useTranslation } from 'react-i18next';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { BrowserRouter } from 'react-router-dom';
import { UserProvider } from './contexts/UserContext';
import { useSettings } from './hooks/useSettings';
import './i18n';
import AppRoutes from './Routes';

export const queryClient = new QueryClient();

function App() {
  const { settings } = useSettings();
  const { i18n } = useTranslation();
  const isSpanish = !i18n.language.startsWith('en');
  const theme = createMuiTheme(
    createTheme({ ...settings }),
    isSpanish ? materialSpanish : materialEnglish
  );
  const localeText = isSpanish
    ? {
        ...pickerSpanish.components.MuiLocalizationProvider.defaultProps
          .localeText,
        previousMonth: 'Mes anterior',
        nextMonth: 'Mes siguiente',
        okButtonLabel: 'Aceptar',
        dateTimePickerDefaultToolbarTitle: 'Seleccionar fecha y hora'
      }
    : pickerEnglish.components.MuiLocalizationProvider.defaultProps.localeText;

  return (
    <LocalizationProvider
      dateAdapter={AdapterDayjs}
      adapterLocale={isSpanish ? 'es' : 'en'}
      localeText={localeText}
    >
      <ThemeProvider theme={theme}>
        <SnackbarProvider>
          <BrowserRouter>
            <UserProvider>
              <QueryClientProvider client={queryClient}>
                <CssBaseline />
                <AppRoutes />
                <ReactQueryDevtools initialIsOpen={false} />
              </QueryClientProvider>
            </UserProvider>
          </BrowserRouter>
        </SnackbarProvider>
      </ThemeProvider>
    </LocalizationProvider>
  );
}

export default App;
